module.exports = __webpack_public_path__ + "assets/ad633133f597551e95cc1e79cce1f1c1.mp3";